<!-- src/components/ui/stepper/Stepper.vue -->
<!-- Modern tab-based stepper design with clean visual indicators -->
<!-- Features horizontal tabs layout with status indicators -->
<!-- RELEVANT FILES: src/components/app-sidebar/nav-team-add.vue, src/lib/utils.ts -->

<script setup lang="ts">
import { cn } from '@/lib/utils';

interface Step {
  id: string;
  title: string;
  description?: string;
  status: 'completed' | 'current' | 'upcoming';
}

interface StepperProps {
  steps: Step[];
  class?: string;
}

const props = defineProps<StepperProps>();
</script>

<template>
  <div :class="cn('w-full', props.class)">
    <!-- Tab Navigation -->
    <div class="flex border-b border-gray-200 dark:border-gray-700">
      <div v-for="step in steps" :key="step.id" class="flex-1 relative">
        <!-- Tab Button -->
        <div
          class="flex items-center justify-center px-4 py-4 text-center cursor-default transition-all duration-200"
          :class="{
            'text-blue-600 bg-blue-50/50 dark:text-blue-400 dark:bg-blue-950/30':
              step.status === 'current',
            'text-green-700 bg-green-50/30 dark:text-green-400 dark:bg-green-950/30':
              step.status === 'completed',
            'text-gray-500 bg-gray-50/30 dark:text-gray-400 dark:bg-gray-800/30':
              step.status === 'upcoming',
          }"
        >
          <!-- Tab Content -->
          <div class="flex-1 min-w-0">
            <div
              class="font-medium text-sm leading-tight"
              :class="{
                'text-blue-700 dark:text-blue-400': step.status === 'current',
                'text-green-700 dark:text-green-400': step.status === 'completed',
                'text-gray-600 dark:text-gray-300': step.status === 'upcoming',
              }"
            >
              {{ step.title }}
            </div>
          </div>
        </div>

        <!-- Active Tab Indicator -->
        <div
          v-if="step.status === 'current'"
          class="absolute bottom-0 left-0 right-0 h-0.5 bg-blue-500"
        />

        <!-- Completed Tab Indicator -->
        <div
          v-else-if="step.status === 'completed'"
          class="absolute bottom-0 left-0 right-0 h-0.5 bg-green-500"
        />
      </div>
    </div>
  </div>
</template>
